<template>
  <div class="ys_apply">
    <div v-show="leaf===1" class="yssq_table" style="margin-top: 20px">
      <div
        style="
          max-width: 1518px;
          background-color: white;
          padding-top: 40px;
          padding-bottom: 57px;
        "
      >
        <div class="tablemes">
          <el-table
            ref="yssqTable"
            :data="tableData"
            border
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
          >
            <el-table-column>
              <template slot="header">
                <el-button v-preventReClick size="mini" class="deleteButton" icon="el-icon-upload" @click="addAdTypeSwitch">新增广告类型</el-button>
              </template>
              <el-table-column align="center" show-overflow-tooltip prop="adTypeName" label="广告类型名称" />
              <el-table-column label="广告类型图片">
                <template slot-scope="scope">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="getPicUrl(scope.row.adTypeImg)"
                    :preview-src-list="getPicUrlArr(scope.row.adTypeImg)"
                    fit="scale-down"
                  />
                </template>
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip prop="orderNum" label="显示顺序" />
              <el-table-column align="center" show-overflow-tooltip label="状态">
                <template slot-scope="scope">
                  <span v-text="scope.row.status === '1'? '停用': '正常'"></span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="adTypeShow(scope.row.adTypeId)">查看</el-button>
                  <el-button type="text" size="small" @click="editAdTypeSwitch(scope.row)">编辑类型</el-button>
                  <el-button type="text" size="small" @click="delAdType(scope.row.adTypeId)">删除</el-button>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <el-pagination
            background
            layout="prev, pager,next,jumper,total,sizes"
            :page-sizes="[10, 20, 30, 40]"
            :total="total"
            :page-size="pagesize"
            class="el-page"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </div>

    <el-dialog title="编辑广告类型" :visible.sync="adTypeFlag">
      <!-- 编辑广告类型 -->
      <el-form :model="adTypeForm" label-width="80px" style="margin: 20px">
        <el-form-item label="类型名称">
          <el-input v-model="adTypeForm.adTypeName"/>
        </el-form-item>
        <el-form-item label="类型图片">
          <el-upload
            ref="upload"
            class="upload-demo"
            :action="returnSaveFile"
            :headers="token"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            list-type="picture"
          >
            <el-button v-show="adTypeImageFlag" size="small" type="primary">点击上传</el-button>
            <div v-show="adTypeImageFlag" slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="显示顺序">
          <el-input v-model="adTypeForm.orderNum" oninput="value=value.replace(/[^\-\d]/g, '')"/>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="adTypeForm.status" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="adTypeFlag = false">取 消</el-button>
        <el-button type="primary" @click="addOrSave">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="新增广告类型" :visible.sync="addAdTypeFlag">
      <!-- 新增广告类型 -->
      <el-form :model="adTypeForm" label-width="80px" style="margin: 20px">
        <el-form-item label="类型名称">
          <el-input v-model="adTypeForm.adTypeName"/>
        </el-form-item>
        <el-form-item label="类型图片">
          <el-upload
            ref="upload"
            class="upload-demo"
            :action="returnSaveFile"
            :headers="token"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            list-type="picture"
          >
            <el-button v-show="adTypeImageFlag" size="small" type="primary">点击上传</el-button>
            <div v-show="adTypeImageFlag" slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="显示顺序">
          <el-input v-model="adTypeForm.orderNum" oninput="value=value.replace(/[^\-\d]/g, '')"/>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="adTypeForm.status" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addAdTypeFlag = false">取 消</el-button>
        <el-button type="primary" @click="addOrSave">确 定</el-button>
      </div>
    </el-dialog>

    <div v-show="leaf==2" class="yssq_table">
      <div
        style="
          max-width: 1518px;
          background-color: white;
          padding-top: 40px;
          padding-bottom: 57px;
        "
      >
        <div class="tablemes">
          <el-table
            ref="yssqTable"
            :data="adData"
            border
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
          >
            <el-table-column>
              <template slot="header">
                <el-button v-preventReClick size="mini" class="deleteButton" icon="el-icon-upload" @click="addAdDataSwitch">新增数据</el-button>
                <el-button size="mini" class="warning" icon="el-icon-back" @click="backLeaf">返回</el-button>
              </template>
              <el-table-column align="center" show-overflow-tooltip prop="adDataName" label="广告数据名称" />
              <el-table-column label="广告数据图片">
                <template slot-scope="scope">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="getPicUrl(scope.row.adDataImg)"
                    :preview-src-list="getPicUrlArr(scope.row.adDataImg)"
                    fit="scale-down"
                  />
                </template>
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip prop="orderNum" label="显示顺序"/>
              <el-table-column align="center" show-overflow-tooltip label="状态">
                <template slot-scope="scope">
                  <span v-text="scope.row.status === '1'? '停用': '正常'"></span>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="editAdDataSwitch(scope.row)">编辑</el-button>
                  <el-button type="text" size="small" @click="editAdContSwitch(scope.row)">编辑广告内容</el-button>
                  <el-button type="text" size="small" @click="delAdData(scope.row.adDataId)">删除</el-button>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <el-pagination
            background
            layout="prev, pager,next,jumper,total,sizes"
            :page-sizes="[10, 20, 30, 40]"
            :total="totalData"
            :page-size="pagesizeData"
            class="el-page"
            :current-page.sync="currentPageData"
            @current-change="handleCurrentChangeData"
            @size-change="handleSizeChangeData"
          />
        </div>
      </div>
    </div>

    <el-dialog title="新增数据" :visible.sync="adAddDataFlag">
      <!-- 新增广告数据 -->
      <el-form :model="adDataForm" label-width="80px" style="margin: 20px">
        <el-form-item label="数据名称"><el-input v-model="adDataForm.adDataName" /></el-form-item>
        <el-form-item label="数据图片">
          <el-upload
            ref="upload"
            class="upload-demo"
            :action="returnSaveFile"
            :headers="token"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            list-type="picture"
          >
            <el-button v-show="adTypeImageFlag" size="small" type="primary">点击上传</el-button>
            <div v-show="adTypeImageFlag" slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="显示顺序">
          <el-input v-model="adDataForm.orderNum" oninput="value=value.replace(/[^\-\d]/g, '')"/>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="adDataForm.status" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="adAddDataFlag = false">取 消</el-button>
        <el-button type="primary" @click="addOrSaveAdData">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="广告数据" :visible.sync="adDataFlag">
      <!-- 编辑广告数据 -->
      <el-form :model="adDataForm" label-width="80px" style="margin: 20px">
        <el-form-item label="数据名称">
          <el-input v-model="adDataForm.adDataName" />
        </el-form-item>
        <el-form-item label="数据图片">
          <el-upload
            ref="upload"
            class="upload-demo"
            :action="returnSaveFile"
            :headers="token"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            list-type="picture"
          >
            <el-button v-show="adTypeImageFlag" size="small" type="primary">点击上传</el-button>
            <div v-show="adTypeImageFlag" slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="显示顺序">
          <el-input v-model="adDataForm.orderNum" oninput="value=value.replace(/[^\-\d]/g, '')"/>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="adDataForm.status" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="adDataFlag = false">取 消</el-button>
        <el-button type="primary" @click="editAdType">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="广告内容" :visible.sync="adDataContFlag">
      <!-- 编辑广告内容 -->
      <div id="dfEditor" style="width: 100%;"/>
      <div slot="footer" class="dialog-footer">
        <el-button @click="adDataContFlag = false">取 消</el-button>
        <el-button type="primary" @click="saveAdDataContent">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import E from 'wangeditor'
import { getToken, returnSaveFile, returnShowPic } from '@/assets/js/common'
import {
  adContentAddOrSave,
  adDataAddOrSave,
  adDataDel,
  adTypeAddOrSave,
  adTypeDel, getAdContent,
  getAdDataPageAll,
  getAdTypePageAll
} from '@/assets/js/tg'

export default {
  props: {},
  data() {
    return {
      returnShowImg: returnShowPic(), // 图片显示前缀
      leaf: 1, // 1类型 2数据 3数据内容
      adTypeFlag: false, // 广告类型编辑标志位
      addAdTypeFlag: false, // 广告类型新增标志位
      adDataFlag: false, // 广告数据编辑标志位
      adAddDataFlag: false, // 广告数据编辑标志位
      adTypeImageFlag: true, // 广告类型编辑标志位
      adDataImageFlag: true, // 广告数据编辑标志位
      adDataContFlag: true, // 广告内容编辑标志位
      nowAdTypeId: '', // 当前广告类型id
      nowAdDataId: '', // 当前广告数据id
      nowAdContendId: '', // 当前广告内容id
      hxBeforeFlag: false,
      returnSaveFile: '', // 上传图片
      leixing: '',
      content: {},
      titleText: '',
      dialogVisible: false,
      adTypeForm: {
        adTypeId: '',
        adTypeName: '',
        adTypeImg: '',
        orderNum: '',
        status: ''
      },
      adDataForm: {
        adDataId: '',
        adTypeId: '',
        adDataName: '',
        adDataImg: '',
        adContentId: '',
        orderNum: '',
        status: ''
      },
      table: [{
        key: 'xkzBh',
        label: '许可证编号'
      }, {
        key: 'hxpMc',
        label: '化学品'
      }],
      tableData: [], // 类型表格数据
      adData: [], // 类型内容表格数据
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      totalData: 0, // 总条数Data
      currentPageData: 1, // 当前页Data
      pagesizeData: 10, // 每页的数据条数Data
      searchForm: {
        province: '', // 省
        company: '' // 公司
      },
      token: {
        Authorization: getToken()
      },
      multipleSelection: [],
      options: [
        {
          value: '0',
          label: '正常'
        }, {
          value: '1',
          label: '停用'
        }
      ],
      URL1: '',
      msgForm: {
        // 留言板表单
        value: []
      }
    }
  },
  computed: {},
  watch: {},
  created() {
    // 获取广告类型
    this.getTableData()
  },
  mounted() {
    this.$nextTick(function() {
      // 初始化富文本
      this.initDfEditor()
    })
    this.returnSaveFile = returnSaveFile()
  },

  beforeDestroy() {
  },
  methods: {
    adTypeShow(adTypeId) {
      // 广告数据查看
      this.leaf = 2
      this.nowAdTypeId = adTypeId
      this.handleCurrentChangeData(1)
      // getAdDataPageAll(this.currentPage, this.pagesize, adTypeId)
      //   .then(e => {
      //     this.adData = e.data.data.records
      //     this.totalData = e.data.total
      //   })
    },
    backLeaf() {
      // 返回上一层
      this.leaf--
    },
    addAdTypeSwitch(row) {
      // 新增广告类型开关
      this.addAdTypeFlag = true
      this.adTypeForm.adTypeId = ''
      this.adTypeForm.adTypeName = ''
      this.adTypeForm.adTypeImg = ''
      this.adTypeForm.orderNum = ''
      this.adTypeForm.status = ''
      this.adTypeImageFlag = true
      if (this.$refs.upload !== undefined && this.$refs.upload.uploadFiles.length > 0) {
        this.$refs.upload.clearFiles()
      }
    },
    editAdTypeSwitch(row) {
      // 编辑广告类型开关
      this.adTypeFlag = !this.adTypeFlag
      this.adTypeForm.adTypeId = row.adTypeId
      this.adTypeForm.adTypeName = row.adTypeName
      this.adTypeForm.adTypeImg = row.adTypeImg
      this.adTypeForm.orderNum = row.orderNum
      this.adTypeForm.status = row.status
      this.adTypeImageFlag = true
      if (this.$refs.upload !== undefined && this.$refs.upload.uploadFiles.length > 0) {
        this.$refs.upload.clearFiles()
      }
    },
    editAdType() {
      // 编辑广告类型开关
      this.addOrSaveAdData(this.adDataForm)
    },
    addAdDataSwitch(row) {
      // 新增广告数据开关
      this.adAddDataFlag = true
      this.adTypeImageFlag = true
      if (this.$refs.upload !== undefined && this.$refs.upload.uploadFiles.length > 0) {
        this.$refs.upload.clearFiles()
      }
      this.adDataForm.adDataId = ''
      this.adDataForm.adTypeId = ''
      this.adDataForm.adDataName = ''
      this.adDataForm.adDataImg = ''
      this.adDataForm.adContentId = ''
      this.adDataForm.orderNum = ''
      this.adDataForm.status = ''
    },
    editAdDataSwitch(row) {
      // 编辑广告数据开关
      this.adDataFlag = true
      this.adDataForm.adDataId = row.adDataId
      this.adDataForm.adTypeId = row.adTypeId
      this.adDataForm.adDataName = row.adDataName
      this.adDataForm.adDataImg = row.adDataImg
      this.adDataForm.adContentId = row.adContentId
      this.adDataForm.orderNum = row.orderNum
      this.adDataForm.status = row.status
      this.adTypeImageFlag = true
      if (this.$refs.upload !== undefined && this.$refs.upload.uploadFiles.length > 0) {
        this.$refs.upload.clearFiles()
      }
    },
    editAdContSwitch(row) {
      // 编辑广告内容开关
      this.adDataContFlag = !this.adDataContFlag
      this.nowAdDataId = row.adDataId
      // eslint-disable-next-line no-empty
      if (row.adContentId !== null) {
        getAdContent(row.adContentId).then((e) => {
          this.dfEditor.txt.html(e.data.data.content)
        })
      } else {
        this.dfEditor.txt.html('')
      }
    },
    addOrSaveAdData() {
      // 新增或编辑 广告类型
      this.adDataForm.adTypeId = this.nowAdTypeId
      adDataAddOrSave(this.adDataForm).then(() => {
        this.adTypeImageFlag = true
        this.adAddDataFlag = false
        getAdDataPageAll(this.currentPageData, this.pagesizeData, this.nowAdTypeId)
          .then(e => {
            this.adData = e.data.data.records
            this.totalData = e.data.data.total
            this.adDataFlag = false
          })
      })
    },
    saveAdDataContent() {
      // 保存内容
      adContentAddOrSave(this.nowAdDataId, {
        content: this.msgForm.adContent
      }).then((e) => {
        this.adDataContFlag = false
        getAdDataPageAll(this.currentPageData, this.pagesizeData, this.nowAdTypeId)
          .then(e => {
            this.adData = e.data.data.records
            this.totalData = e.data.data.total
          })
      })
    },
    delAdType(typeId) {
      // 新增或编辑 广告类型
      this.$confirm('确认是否删除信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          adTypeDel(typeId).then(() => {
            this.getTableData()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    delAdData(typeId) {
      // 新增或编辑 广告类型
      this.$confirm('确认是否删除信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          adDataDel(typeId).then(() => {
            getAdDataPageAll(this.currentPageData, this.pagesizeData, this.nowAdTypeId)
              .then(e => {
                this.adData = e.data.data.records
                this.totalData = e.data.data.total
              })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // eslint-disable-next-line handle-callback-err
    handleSuccess(err, file, fileList) {
      this.adTypeImageFlag = false
      this.adTypeForm.adTypeImg = file.response.data.url
      this.adDataForm.adDataImg = file.response.data.url
    },
    // eslint-disable-next-line handle-callback-err
    handleAdDataSuccess(err, file, fileList) {
      this.adDataImageFlag = false
      this.adDataForm.adDataImg = file.response.data.url
    },
    handleRemove() {
      this.adTypeImageFlag = true
      this.adTypeForm.adTypeImg = ''
      this.adDataForm.adDataImg = ''
    },
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.getTableData()
    },
    handleCurrentChangeData(val) {
      this.currentPageData = val // 当前页
      getAdDataPageAll(this.currentPageData, this.pagesizeData, this.nowAdTypeId)
        .then(e => {
          this.adData = e.data.data.records
          this.totalData = e.data.data.total
        })
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.getTableData()
    },
    // 10条/页改变时
    handleSizeChangeData(val) {
      this.pagesizeData = val
      getAdDataPageAll(this.currentPageData, this.pagesizeData, this.nowAdTypeId)
        .then(e => {
          this.adData = e.data.data.records
          this.totalData = e.data.data.total
        })
    },
    getTableData() {
      getAdTypePageAll({
        param: this.searchForm,
        page: this.currentPage,
        size: this.pagesize
      }).then((e) => {
        this.tableData = e.data.data.records
        this.total = e.data.data.total
      })
    },
    addOrSave() {
      adTypeAddOrSave(this.adTypeForm).then(() => {
        this.addAdTypeFlag = false
        this.getTableData()
        this.adTypeImageFlag = true
        this.adTypeFlag = false
      })
    },
    initDfEditor() {
      if (this.dfEditor) return
      this.dfEditor = new E('#dfEditor') // 通过id拉取div
      this.adDataContFlag = false
      this.dfEditor.config.menuTooltipPosition = 'up' // 菜单位置
      this.dfEditor.config.zIndex = 1 // 层级  解决上方选择器的浮层显示异常问题
      this.dfEditor.config.uploadImgMaxSize = 200 * 1024 // 200k  限制文件大小
      this.dfEditor.config.uploadImgShowBase64 = true
      this.dfEditor.config.showLinkImg = false // 隐藏插入网络图片的功能
      this.dfEditor.config.placeholder = ''
      this.dfEditor.config.uploadFileName = 'file'
      this.dfEditor.config.uploadImgAccept = [
        // 限制上传文件类型
        'jpg',
        'jpeg',
        'png',
        'gif',
        'bmp',
        'webp'
      ]
      this.dfEditor.config.uploadImgHeaders = {
        // 自定义header
        Authorization: getToken()
      }
      this.dfEditor.config.onchange = (html) => {
        // html 绑定值
        this.msgForm.adContent = html
        // this.content = dfEditor.txt.text();  纯文本
      }
      this.dfEditor.config.menus = [
        // 自定义菜单配置
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'quote', // 引用
        'image', // 插入图片
        'undo', // 撤销
        'redo' // 重复
      ]
      this.dfEditor.create()
    },
    getPicUrl(picUrl) {
      return returnShowPic() + picUrl
    },
    getPicUrlArr(picUrl) {
      const picArr = []
      picArr.push(returnShowPic() + picUrl)
      return picArr
    }
  }
}
</script>
<style scoped lang="less">
/deep/ .el-form--inline .el-form-item__content {
  display: inline-block;
  vertical-align: middle !important;
}

/deep/ .el-table--border {
  border-right: none;
  border-bottom: none;
  z-index: 0 !important;
}

.ys_apply {
  .headerSearch {
    max-width: 1518px;
    height: 96px;
    margin-bottom: 10px;
    margin-top: 35px;
    background-color: white;
    // padding: 30px 0 20px 0;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;

    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;

      &:last-child {
        width: 90px;
        height: 39px;

        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }

  .yssq_table {
    width: 95%;
    max-width: 1503px;
    // min-width: 1100px;
    margin: auto;
  }

  /deep/ .el-table .cell,
  /deep/ .el-table--border td:first-child .cell,
  /deep/ .el-table--border th:first-child .cell {
    padding-left: 8px !important;
  }

  .el-table td,
  .el-table th.is-leaf {
    border-bottom: 1px solid #ebeef5;
    text-align: center;
  }

  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;

    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      border-radius: 20px;
      border-color: #4170ff;
    }

    /deep/ .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      // &:last-child {
      //   // width: 90px;
      //   height: 39px;
      // }
    }
  }

  .tablemes {
    width: 90%;
    margin: auto;
    max-width: 1375px;
    // margin-top: 21px;
    // margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }

    .el-pagination {
      padding: 10px 0;
      border: 1px solid #ebeef5;
      border-top: 0;
    }

    // .addButton {
    //   color: #fff;
    //   background: #4170ff;
    //   border-radius: 3px;
    //   border-color: #4170ff;
    // }
    .el-button--warning {
      color: #fff;
      background: #fe5622;
      border-radius: 3px;
      border-color: #fe5622;
    }

    .el-button--primary {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }

    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }

    .shanchu {
      border-color: #ff4c00;
      background: #ff4c00;
      color: #fff;
      width: 65px;
      padding: 7px 9px;
    }
  }

  .el-page {
    // width: 90px;
    // height: 39px;
    .el-pager {
      .active {
        background: #4170ff;
        border-radius: 3px;
        border-color: #4170ff;
      }
    }
  }
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}

/deep/ .has-gutter {
  .el-checkbox {
    display: none;
  }
}
</style>
